import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-closing-remarks-modal',
  templateUrl: './closing-remarks-modal.component.html',
  styleUrls: ['./closing-remarks-modal.component.scss']
})
export class ClosingRemarksModalComponent implements OnInit {
  closingRemarks: string = null;
  @ViewChild('modal') modal;
  modalRef: NgbModalRef;

  @Output() submit: EventEmitter<string> = new EventEmitter<string>();
  constructor(private modalService: NgbModal) { }


  ngOnInit(): void {
  }

  // handle the popup
  open() {
    this.modalRef = this.modalService.open(this.modal, { centered: true, size: 'md' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    this.close();
    this.submit.emit(this.closingRemarks);
  }
}
